module.exports = __webpack_public_path__ + "static/img/p_17.3d45e01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_17.jpg
// module id = RjLm
// module chunks = 9